var SelectField = require('modules/select-field');
var TinyDatePicker = require('tiny-date-picker');

function RewardsRegister(el) {
	var t = this;
	t.el = el;
	t.dateField = t.el.querySelector('.js-date');
	t.timeSelect = null;

	if (! t.dateField) {
		return;
	}
	t.timeField = t.el.querySelector('.js-time');

	if (! t.timeField) {
		return;
	}

	t.timeFieldSelect = t.timeField.querySelector('[data-field-mobile]');
	t.timeFieldName = t.timeField.querySelector('[data-field-mobile]').name;

	t.populateTimeField();

	t.dateField.addEventListener('change', t.populateTimeField.bind(t));
}

RewardsRegister.prototype.populateTimeField = function () {
	var t = this;
	var date = t.dateField.value;

	$.ajax({
		type: 'GET',
		url: '/wp-json/crr/v2/slots/' + date,
		success: function(data) {
			t.timeField.innerHTML = '';

			if (data) {
				var list = [];
				Object.keys(data.slots).map(function(time) {
					var slot = data.slots[time];
					list.push({
						value: time,
						text: slot
					});
				});
				t.generateFieldData( list, data.selected );
			}
		},
		dataType: 'json'
	});
};

RewardsRegister.prototype.generateBlankFields = function() {
	var t = this;
	var markup = document.createElement('div');
	markup.className = 'select-field';
	markup.innerHTML = '<div class="select-field__inner"><div class="h6 c-secondary-brand select-field__current" data-field-current>Time (Select date first)</div><div class="select-field__desktop"></div><div class="select-field__mobile"></div><span class="select-field__arrow"></span></div>';
	t.timeField.appendChild(markup);
};

RewardsRegister.prototype.generateFieldData = function( arr, selected ) {
	var t = this;

	t.generateBlankFields();
	t.populateMobileFields( arr, t.timeField.querySelector('.select-field__mobile') );
	t.populateDesktopFields( arr, t.timeField.querySelector('.select-field__desktop') );

	var selectFieldEl = t.timeField.querySelector('.select-field');

	if (t.timeSelect) {
		t.timeSelect.destroy();
	}

	t.timeSelect = new SelectField(selectFieldEl);
	if (selected) {
		t.timeSelect.fieldMobile.value = selected;
	}

	if (arr.length) {
		t.timeSelect.selectFirstItem();
	}
};

RewardsRegister.prototype.populateDesktopFields = function( arr, target) {
	var t = this;
	var list = document.createElement('ul');
	list.className = 'caption c-secondary-brand select-field__dropdown';
	list.setAttribute('data-field-desktop', '');
	arr.map( function( item ) {
		var opt = document.createElement('li');
		opt.setAttribute('data-value', item.value);
		opt.textContent = item.text;
		opt.className = 'select-field__dropdown-item';
		list.appendChild(opt);
	});
	target.appendChild(list);
};

RewardsRegister.prototype.populateMobileFields = function( arr, target ) {
	var t = this;
	var select = document.createElement('select');
	select.className = 'caption c-secondary-brand js-field-mobile';
	select.setAttribute('data-field-mobile', '');
	select.name = t.timeFieldName;
	select.required = true;
	arr.map( function( item ) {
		var opt = document.createElement('option');
		opt.value = item.value;
		opt.textContent = item.text;
		select.appendChild(opt);

	});
	target.appendChild( select );
};

module.exports = RewardsRegister;
